import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const waterfallValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'y2', type: ['string', 'date'], required: true }
  ],
  businessRules: [
    {
      name: 'waterfall-sufficient-data',
      validator: data => data.length >= 3,
      message: 'Waterfall chart requires at least 3 data points to form a meaningful flow',
      suggestion: 'Provide at least 3 data points to show waterfall progression',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'waterfall-group-completeness',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (data.length < 3) {
          return true;
        }

        // 按y2字段分组
        const groups = {} as Record<string, unknown[]>;
        data.forEach(item => {
          const timeKey = String(item[encoding?.y2 as string]);
          groups[timeKey] = groups[timeKey] || [];
          groups[timeKey].push(item);
        });

        // 检查是否至少有一个组包含足够的数据点
        return Object.values(groups).some(group => group.length >= 3);
      },
      message: 'Waterfall chart requires at least one time group with 3 or more data points',
      suggestion: 'Ensure each time period has sufficient data points for waterfall visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'waterfall-value-variation',
      validator: (data, layer) => {
        const { encoding } = layer;
        const yValues = data.map(item => Number(item[encoding?.y as string]));

        // 检查是否有正负值变化（瀑布图特点）
        const hasPositive = yValues.some(val => val > 0);
        const hasNegative = yValues.some(val => val < 0);

        // 至少有一种方向的变化
        return hasPositive || hasNegative;
      },
      message: 'Waterfall chart works best with varying positive/negative values',
      suggestion: 'Include both positive and negative values to show waterfall effect',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
